import { Antenna } from 'lucide-react'
import type { CSSProperties } from 'react'
import { getIcon } from '@/components/BaseData/appearance/icons/getIcon'
import { kebabToPascal } from '@/components/BaseData/appearance/icons/slug'
import { cn } from '@/lib/utils'

type AvatarSize = 'sm' | 'md' | 'lg'

interface ChannelAvatarProps {
  /** Slug lucide kebab vindo do back; null/desconhecido → Antenna. */
  icon?: string | null
  /** Hex #RRGGBB; null → visual default (gradiente primary, look do .avatar-initials). */
  color?: string | null
  size?: AvatarSize
  className?: string
}

const BOX: Record<AvatarSize, string> = {
  sm: 'size-8 rounded-lg',
  md: 'size-12 rounded-xl',
  lg: 'size-[100px] rounded-[2rem] border-4',
}

const ICON: Record<AvatarSize, string> = {
  sm: 'size-4',
  md: 'size-6',
  lg: 'size-9',
}

/** Sufixos hex-alpha determinísticos (testáveis em jsdom, sem color-mix). */
const BG_ALPHA = '26' // 15%
const BORDER_ALPHA = '59' // 35%

export function ChannelAvatar({ icon, color, size = 'md', className }: ChannelAvatarProps) {
  const Icon = getIcon(icon ? kebabToPascal(icon) : undefined) ?? Antenna
  const tinted: CSSProperties | undefined = color
    ? { color, backgroundColor: `${color}${BG_ALPHA}`, borderColor: `${color}${BORDER_ALPHA}` }
    : undefined

  return (
    <div
      aria-hidden="true"
      style={tinted}
      className={cn(
        'flex shrink-0 items-center justify-center border',
        BOX[size],
        !color && 'border-white/10 bg-gradient-to-br from-primary to-purple-500 text-white',
        className,
      )}
    >
      <Icon className={ICON[size]} />
    </div>
  )
}
